import { type GameMenuDefinitionItem } from '@app-types/main/menu'

export const gameSidebarMenuItems: GameMenuDefinitionItem[] = [
  { isHeader: true, title: 'Summary', url: '' },
  { title: 'Summary', url: '/summary/' },
  { title: 'LTV', url: '/ltv/' },
  { title: 'Ретеншн', url: '/retention/' },
  { title: 'Ретеншн экспорт', url: '/retention/export/' },
  { title: 'Сессии', url: '/mx/sessions/' },
  { title: 'По часам', url: '/mx/hourly/' },

  { isHeader: true, title: 'Платежи', url: '' },
  { title: 'По дням', url: '/payments/' },
  { title: 'По часам', url: '/payments/per-hour/' },
  { title: 'По игрокам', url: '/payments/top-users/' },
  { title: 'Когда-сколько', url: '/payments/raw/' },
  { title: 'По игровым дням', url: '/payments/game-days/' },
  { feature: 'payment-items', title: 'Покупки', url: '/payments/items/' },

  { isHeader: true, title: 'Прочее', url: '' },
  { title: 'AB', url: '/ab/' },
  { feature: 'game-resources', title: 'Игровые ресурсы', url: '/game/resources/' },
  { feature: 'loading-report', title: 'Загрузка', url: '/game/loading/' },
  { feature: 'game-tutor', title: 'Тутор', url: '/game/tutor/' },
  {
    perm: 'user.game_users',
    title: 'Блэк лист',
    url: '/mx/settings/blacklist/',
  },
  {
    feature: 'cwapk-af-entities',
    title: 'Entities',
    url: '/cwapk/af/entities/',
  },
  { title: 'Постбэки', url: '/postbacks/' },
]
